// extracted by mini-css-extract-plugin
module.exports = {"block":"Subscription_block__2Y5c6","center":"Subscription_center__3yGro","resume":"Subscription_resume__3WryO"};